import type { SubscriptionCategoryItem } from './helpers/subscription-categories-cache';
import type { FindManyCategoryQueryResponse, GraphQLResponse, SubscriptionCategoryOption } from './types';

export const mapCategoriesToOptions = (
  categories: readonly SubscriptionCategoryItem[] | null | undefined,
): readonly SubscriptionCategoryOption[] => {
  if (!categories?.length) {
    return [];
  }

  return categories
    .filter((category): category is SubscriptionCategoryItem & { _id: string; name: string } => {
      return typeof category?._id === 'string' && typeof category?.name === 'string' && category.name.trim().length > 0;
    })
    .map((category) => ({
      label: category.name,
      value: category._id,
    }));
};

export const normalizeCategoryIds = (
  categories: readonly SubscriptionCategoryOption[] | null | undefined,
): string[] => {
  if (!categories?.length) {
    return [];
  }

  return categories
    .map((item) => item?.value)
    .filter((value): value is string => typeof value === 'string' && value.trim().length > 0);
};

export const extractCategoriesFromResponse = (
  result: GraphQLResponse<FindManyCategoryQueryResponse>,
): readonly SubscriptionCategoryItem[] => {
  return result.data?.findManyCategoryQuery ?? [];
};
